// import { useEffect, useMemo, useState } from 'react';
// import { useDispatch } from 'react-redux';
// import { Eye, X } from 'lucide-react';

// import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
// import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';
// import SalarySlip from '../../../components/PayRoll/SalarySlip';

// import usePayrollEntity from '../../../utils/usePayrollEntity';
// import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
// import { buildSalarySlipBreakdown } from '../../../utils/salarySlip';
// import { getPayrollDetailsBySno } from '../../../action/Payroll';

// const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
// const LABEL = TABLE_THEME.fieldLabel;

// const PayrollHeader = () => {
//   const dispatch = useDispatch();

//   const { list: periods } = usePayrollEntity('payrollPeriods');
//   const { list: employeeSalaries, loading: salariesLoading } = usePayrollEntity('employeeSalary');

//   const [selectedPeriodId, setSelectedPeriodId] = useState('');
//   const [viewing, setViewing] = useState(null); // header row currently shown in the dialog
//   const [payrollDetails, setPayrollDetails] = useState(null);
//   const [detailsLoading, setDetailsLoading] = useState(false);
//   const [detailsError, setDetailsError] = useState('');
//   const [refreshing, setRefreshing] = useState(false);

//   // useEffect(() => {
//   //   if (!selectedPeriodId && periods.length > 0) {
//   //     setSelectedPeriodId(String(periods[0].id));
//   //   }
//   // }, [periods, selectedPeriodId]);

//   const filteredSalaries = useMemo(() => {
//     if (!selectedPeriodId) {
//       return [];
//     }

//     return employeeSalaries.filter(
//       (salary) =>
//         // String(salary.payrollPeriodId) === String(selectedPeriodId) &&
//         salary.isActive &&
//         salary.isCurrent
//     );
//   }, [employeeSalaries, selectedPeriodId]);

//   const rows = useMemo(() => {
//     return filteredSalaries.map((salary) => ({
//       id: salary.id,
//       employeeId: salary.employeeId,
//       empNo: salary.empNo || '-',
//       name: salary.name || `Employee #${salary.employeeId}`,
//       payrollPeriodId: salary.payrollPeriodId,
//       salaryReference: salary.salaryReference,
//       basicSalary: salary.basic,
//       grossSalary: salary.grossSalary,
//       workingDays: salary.workingDays,
//       dailyRate: salary.dailyRate,
//       status: salary.status,
//     }));
//   }, [filteredSalaries]);

//   const selectedPeriod = useMemo(() => {
//     return periods.find((period) => String(period.id) === String(selectedPeriodId));
//   }, [periods, selectedPeriodId]);

//   const handleViewSalarySlip = async (row, periodId) => {
//     setViewing(row);
//     setPayrollDetails(null);
//     setDetailsError('');
//     setDetailsLoading(true);
//     try {
//       const result = await dispatch(getPayrollDetailsBySno(selectedPeriodId, row.empNo));
//       setPayrollDetails(result);
//     } catch (error) {
//       console.error('Failed to load payroll details:', error);
//       setDetailsError(error?.message || 'Unable to load the salary slip.');
//     } finally {
//       setDetailsLoading(false);
//     }
//   };

//   const handleCloseSlip = () => {
//     setViewing(null);
//     setPayrollDetails(null);
//     setDetailsError('');
//     setDetailsLoading(false);
//   };

//   const breakdown = useMemo(() => {
//     if (!payrollDetails) {
//       return null;
//     }
//     return buildSalarySlipBreakdown(payrollDetails);
//   }, [payrollDetails]);

//   const viewingEmployee = useMemo(() => {
//     if (!viewing) {
//       return null;
//     }
//     return {
//       name: viewing.name,
//       empNo: viewing.empNo,
//     };
//   }, [viewing]);

//   const viewingPeriod = useMemo(() => {
//     if (payrollDetails) {
//       return (
//         periods.find(
//           (period) => String(period.id) === String(payrollDetails.HPH_PAYROLL_PERIOD_ID)
//         ) || selectedPeriod
//       );
//     }

//     return selectedPeriod;
//   }, [payrollDetails, periods, selectedPeriod]);

//   // Normalize HPH_* backend response into the shape expected by SalarySlip
//   const salarySlipHeader = useMemo(() => {
//     if (!payrollDetails) {
//       return null;
//     }
//     return {
//       payrollNo: payrollDetails.HPH_PAYROLL_NO,
//       payrollPeriodId: payrollDetails.HPH_PAYROLL_PERIOD_ID,
//       employeeId: payrollDetails.HPH_EMPLOYEE_ID,
//       employeeSalaryId: payrollDetails.HPH_EMPLOYEE_SALARY_ID,
//       payDate: payrollDetails.HPH_PAY_DATE
//         ? String(payrollDetails.HPH_PAY_DATE).split(' ')[0]
//         : '',
//       grossEarnings: Number(payrollDetails.HPH_GROSS_EARNINGS || 0),
//       totalEarnings: Number(payrollDetails.HPH_TOTAL_EARNINGS || 0),
//       totalDeductions: Number(payrollDetails.HPH_TOTAL_DEDUCTIONS || 0),
//       employeeEpf: Number(payrollDetails.HPH_EMPLOYEE_EPF || 0),
//       employerEpf: Number(payrollDetails.HPH_EMPLOYER_EPF || 0),
//       employerEtf: Number(payrollDetails.HPH_EMPLOYER_ETF || 0),
//       paye: Number(payrollDetails.HPH_PAYE || 0),
//       netSalary: Number(payrollDetails.HPH_NET_SALARY || 0),
//       workingDays: Number(payrollDetails.HPH_WORKING_DAYS || 0),
//       presentDays: Number(payrollDetails.HPH_PRESENT_DAYS || 0),
//       noPayDays: Number(payrollDetails.HPH_NO_PAY_DAYS || 0),
//       otHours: Number(payrollDetails.HPH_OT_HOURS || 0),
//       status: payrollDetails.HPH_STATUS,
//       remarks: payrollDetails.HPH_REMARKS,
//     };
//   }, [payrollDetails]);

//   // Fake refresh
//   const refreshTable = () => {
//     setRefreshing(true);

//     setTimeout(() => {
//       setRefreshing(false)
//     }, 500);
//   };

//   return (
//     <div className="p-6 space-y-4">
//       <Breadcrumb
//         trail={['Payroll', 'Payroll Header']}
//         title="Payroll Header"
//         subtitle="Payment details per employee and payroll period. View an employee's salary slip, print it, or download it as a PDF."
//       />

//       <Table
//         title="Payroll Header"
//         loading={salariesLoading || refreshing}
//         loadingMessage="Refreshing payroll records..."
//         rows={rows}
//         rowKey="id"
//         search
//         searchLabel="Search"
//         searchKeys={['empNo', 'name', 'salaryReference']}
//         searchPlaceholder="Search by employee name, number or salary reference..."
//         emptyMessage={
//           selectedPeriodId
//             ? 'No payroll records for this period.'
//             : 'Select a payroll period to view records.'
//         }
//         pageSize={8}
//         scrollClassName=""
//         toolbarExtra={
//           <div className="w-[260px] max-w-full">
//             <span className={LABEL}>Period ID</span>
//             <select
//               value={selectedPeriodId}
//               onChange={(event) => {
//                 setSelectedPeriodId(event.target.value);
//                 handleCloseSlip();
//                 refreshTable();
//               }}
//               className={`${FIELD} w-full`}
//             >
//               <option value="">-- Select Period --</option>
//               {periods
//                 .filter((period) => period.status === "Inactive")
//                 .map((period) => (
//                   <option key={period.id} value={String(period.id)}>
//                     {period.name}
//                   </option>
//                 ))
//               }
//             </select>
//           </div>
//         }
//         columns={[
//           {
//             key: 'name',
//             label: 'Employee',
//             grow: true,
//             className: 'font-semibold text-gray-900',
//             render: (row) => `${row.name} (${row.empNo})`,
//           },
//           { key: 'salaryReference', label: 'Salary Reference', className: 'text-gray-600' },
//           {
//             key: 'basicSalary',
//             label: 'Basic Salary (Rs)',
//             align: 'right',
//             className: 'text-gray-700',
//             render: (row) => fmtMoney(row.basicSalary),
//           },
//           {
//             key: 'grossSalary',
//             label: 'Gross Salary (Rs)',
//             align: 'right',
//             className: 'font-semibold text-gray-900',
//             render: (row) => fmtMoney(row.grossSalary),
//           },
//           {
//             key: 'status',
//             label: 'Status',
//             align: 'center',
//             render: (row) => <StatusPill label={row.status} />,
//           },
//           {
//             key: 'actions',
//             label: 'Actions',
//             align: 'center',
//             sortable: false,
//             render: (row) => (
//               <button
//                 type="button"
//                 onClick={() => handleViewSalarySlip(row)}
//                 className="inline-flex items-center gap-1.5 h-7 px-2 rounded-md text-[12px] font-semibold
//                   text-primary-700 hover:bg-primary-50 transition-colors"
//               >
//                 <Eye size={14} />
//                 View Salary Slip
//               </button>
//             ),
//           },
//         ]}
//       />

//       {/* ── Salary slip ──────────────────────────────────────────────
//           SalarySlip prints itself through a stylesheet that hides
//           everything except #salary-slip-print, and hides anything marked
//           .salary-slip-actions — so the close button keeps that class. */}
//       {viewing && (
//         <div
//           className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 px-4 py-8"
//           onClick={handleCloseSlip}
//         >
//           <div
//             className="relative w-full max-w-2xl rounded-xl bg-[#F7F7F7] shadow-lg"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               onClick={handleCloseSlip}
//               aria-label="Close"
//               className="salary-slip-actions absolute right-3 top-3 z-10 inline-flex h-8 w-8 items-center
//                 justify-center rounded-md text-gray-500 hover:bg-gray-200 hover:text-gray-700 transition-colors"
//             >
//               <X size={18} />
//             </button>

//             <div className="px-4 pb-4 pt-12">
//               {detailsLoading && (
//                 <div className="py-20 text-center text-sm text-gray-400">Loading salary slip...</div>
//               )}

//               {!detailsLoading && detailsError && (
//                 <div className="py-16 text-center text-sm text-red-700">{detailsError}</div>
//               )}

//               {!detailsLoading && !detailsError && payrollDetails && breakdown && salarySlipHeader && (
//                 <SalarySlip
//                   employee={viewingEmployee}
//                   period={viewingPeriod}
//                   header={salarySlipHeader}
//                   breakdown={breakdown}
//                 />
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default PayrollHeader;


import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Download, Eye, Loader2, Printer, RotateCw, X } from 'lucide-react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';
import SalarySlip from '../../../components/PayRoll/SalarySlip';
import SearchableSelect from '../../../components/common/SearchableSelect';

import usePayrollEntity from '../../../utils/usePayrollEntity';
import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
import { buildSalarySlipBreakdown } from '../../../utils/salarySlip';
import { fetchPayrollEntityList, fetchPayrollHeadersByPeriod, getPayrollDetailsBySno, reversePayroll, selectPayrollHeaders } from '../../../store/slices/payrollSlice';
import { useConfirm } from '../../../utils/ConfirmContext';
import useToast from '../../../utils/useToast';
import Toast from '../../../components/Toast/Toast';

const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
const LABEL = TABLE_THEME.fieldLabel;

const PayrollHeader = () => {
  const dispatch = useDispatch();
  const confirm = useConfirm();
  const { toast, showToast, hideToast } = useToast();

  const { list: periods } = usePayrollEntity('payrollPeriods');
  const { list: employeeSalaries, loading: salariesLoading } = usePayrollEntity('employeeSalary');

  const { data: periodHeaders, loading: headersLoading } = useSelector(selectPayrollHeaders) || { data: [], loading: false }

  const [selectedPeriodId, setSelectedPeriodId] = useState('');
  const [viewing, setViewing] = useState(null); // header row currently shown in the dialog
  const [payrollDetails, setPayrollDetails] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [detailsError, setDetailsError] = useState('');
  const [refreshing, setRefreshing] = useState(false);
  const [reversing, setReversing] = useState(false);

  const [batchPrintData, setBatchPrintData] = useState([]);
  const [printingBatch, setPrintingBatch] = useState(false);

  // Fetch the headers whenever the selected period changes
  useEffect(() => {
    if (selectedPeriodId) {
      dispatch(fetchPayrollHeadersByPeriod(selectedPeriodId));
    }
  }, [selectedPeriodId, dispatch]);

  // useEffect(() => {
  //   if (!selectedPeriodId && periods.length > 0) {
  //     setSelectedPeriodId(String(periods[0].id));
  //   }
  // }, [periods, selectedPeriodId]);

  const filteredSalaries = useMemo(() => {
    if (!selectedPeriodId) {
      return [];
    }

    return employeeSalaries.filter(
      (salary) =>
        // String(salary.payrollPeriodId) === String(selectedPeriodId) &&
        salary.isActive &&
        salary.isCurrent
    );
  }, [employeeSalaries, selectedPeriodId]);

  const rows = useMemo(() => {
    if (!selectedPeriodId || !periodHeaders) {
      return []
    }

    return periodHeaders.map((header) => {
      // Find the master employee details using HPH_EMPLOYEE_ID
      const empInfo = employeeSalaries.find(
        (emp) => String(emp.employeeId) === String(header.HPH_EMPLOYEE_ID)
      );

      return {
        id: header.HPH_PAYROLL_ID,
        employeeId: header.HPH_EMPLOYEE_ID,
        empNo: empInfo?.empNo || '-',
        name: empInfo?.name || `Employee #${header.HPH_EMPLOYEE_ID}`,
        payrollPeriodId: header.HPH_PAYROLL_PERIOD_ID,
        salaryReference: empInfo?.salaryReference || '-',
        basicSalary: empInfo?.basic || 0,
        grossSalary: Number(header.HPH_GROSS_EARNINGS || 0),
        workingDays: Number(header.HPH_WORKING_DAYS || 0),
        dailyRate: empInfo?.dailyRate || 0,
        status: header.HPH_STATUS === 'C' ? 'Current' : header.HPH_STATUS,
      }
    })
  }, [periodHeaders, employeeSalaries, selectedPeriodId])

  const selectedPeriod = useMemo(() => {
    return periods.find((period) => String(period.id) === String(selectedPeriodId));
  }, [periods, selectedPeriodId]);

  const handleViewSalarySlip = async (row, periodId) => {
    setViewing(row);
    setPayrollDetails(null);
    setDetailsError('');
    setDetailsLoading(true);
    try {
      const result = await dispatch(getPayrollDetailsBySno(selectedPeriodId, row.empNo));
      setPayrollDetails(result);
    } catch (error) {
      console.error('Failed to load payroll details:', error);
      setDetailsError(error?.message || 'Unable to load the salary slip.');
    } finally {
      setDetailsLoading(false);
    }
  };

  const handleCloseSlip = () => {
    setViewing(null);
    setPayrollDetails(null);
    setDetailsError('');
    setDetailsLoading(false);
  };

  const breakdown = useMemo(() => {
    if (!payrollDetails) {
      return null;
    }
    return buildSalarySlipBreakdown(payrollDetails);
  }, [payrollDetails]);

  const viewingEmployee = useMemo(() => {
    if (!viewing) {
      return null;
    }
    return {
      name: viewing.name,
      empNo: viewing.empNo,
    };
  }, [viewing]);

  const viewingPeriod = useMemo(() => {
    if (payrollDetails) {
      return (
        periods.find(
          (period) => String(period.id) === String(payrollDetails.HPH_PAYROLL_PERIOD_ID)
        ) || selectedPeriod
      );
    }

    return selectedPeriod;
  }, [payrollDetails, periods, selectedPeriod]);

  // Normalize HPH_* backend response into the shape expected by SalarySlip
  const salarySlipHeader = useMemo(() => {
    if (!payrollDetails) {
      return null;
    }
    return {
      payrollNo: payrollDetails.HPH_PAYROLL_NO,
      payrollPeriodId: payrollDetails.HPH_PAYROLL_PERIOD_ID,
      employeeId: payrollDetails.HPH_EMPLOYEE_ID,
      employeeSalaryId: payrollDetails.HPH_EMPLOYEE_SALARY_ID,
      payDate: payrollDetails.HPH_PAY_DATE
        ? String(payrollDetails.HPH_PAY_DATE).split(' ')[0]
        : '',
      grossEarnings: Number(payrollDetails.HPH_GROSS_EARNINGS || 0),
      totalEarnings: Number(payrollDetails.HPH_TOTAL_EARNINGS || 0),
      totalDeductions: Number(payrollDetails.HPH_TOTAL_DEDUCTIONS || 0),
      employeeEpf: Number(payrollDetails.HPH_EMPLOYEE_EPF || 0),
      employerEpf: Number(payrollDetails.HPH_EMPLOYER_EPF || 0),
      employerEtf: Number(payrollDetails.HPH_EMPLOYER_ETF || 0),
      paye: Number(payrollDetails.HPH_PAYE || 0),
      netSalary: Number(payrollDetails.HPH_NET_SALARY || 0),
      workingDays: Number(payrollDetails.HPH_WORKING_DAYS || 0),
      presentDays: Number(payrollDetails.HPH_PRESENT_DAYS || 0),
      noPayDays: Number(payrollDetails.HPH_NO_PAY_DAYS || 0),
      otHours: Number(payrollDetails.HPH_OT_HOURS || 0),
      status: payrollDetails.HPH_STATUS,
      remarks: payrollDetails.HPH_REMARKS,
    };
  }, [payrollDetails]);

  // Fake refresh
  const refreshTable = () => {
    setRefreshing(true);

    setTimeout(() => {
      setRefreshing(false)
    }, 500);
  };

  const handleDownloadExcel = async () => {
    if (!rows || rows.length === 0) return;

    const detailsList = await Promise.all(
      rows.map(async (row) => {
        try {
          return await dispatch(getPayrollDetailsBySno(selectedPeriodId, row.empNo));
        } catch {
          return null;
        }
      })
    );

    const validDetails = detailsList.filter(Boolean);

    // 1. Dynamic components
    const earningCompNames = new Set();
    const deductionCompNames = new Set();

    validDetails.forEach((res) => {
      res.PayrollDetails?.forEach((d) => {
        const name = d.HPC_COMPONENT_NAME;
        if (!name) return;

        const code = String(d.HPC_COMPONENT_CODE || '').toUpperCase();
        if (code === 'BASIC' || code === 'BASIC-SAL' || code === 'EPF-EE') return;

        if (d.HPC_COMPONENT_TYPE === 'E') earningCompNames.add(name);
        else if (d.HPC_COMPONENT_TYPE === 'D') deductionCompNames.add(name);
      });
    });

    const dynamicEarnings = Array.from(earningCompNames);
    const dynamicDeductions = Array.from(deductionCompNames);

    // 2. Headers
    const headers = [
      'No',
      'Payroll No',
      'Pay Date',
      'Service No',
      'Employee Name',
      'Salary Reference',
      'Status',
      'Working Days',
      'Present Days',
      'No-Pay Days',
      'Extra Days',
      'OT Hours',
      'Basic Salary (Rs)',
      ...dynamicEarnings.map((name) => `${name} (Rs)`),
      'Gross Earnings (Rs)',
      'Total Earnings (Rs)',
      'EPF Employee 8% (Rs)',
      ...dynamicDeductions.map((name) => `${name} (Rs)`),
      'PAYE / APIT (Rs)',
      'Total Deductions (Rs)',
      'Net Salary (Rs)',
      'Employer EPF 12% (Rs)',
      'Employer ETF 3% (Rs)',
      'Total Employer Cost (Rs)',
    ];

    const workbook = new ExcelJS.Workbook();
    const periodName = selectedPeriod?.name || 'Payroll_Report';
    const worksheet = workbook.addWorksheet('Payroll Summary');

    // 3. Header Row (Starts directly at Row 1)
    const headerRow = worksheet.addRow(headers);
    headerRow.height = 24;

    headerRow.eachCell((cell) => {
      cell.font = { name: 'Calibri', size: 10, bold: true, color: { argb: 'FF9A3412' } }; // Soft dark orange text
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFF7ED' }, // Very light orange/cream
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        bottom: { style: 'thin', color: { argb: 'FFFB923C' } }, // Clean thin accent line
      };
    });

    // 4. Data Rows
    const borderGray = {
      bottom: { style: 'thin', color: { argb: 'FFF3F4F6' } },
    };

    const borderBlack = {
      top: { style: 'thin', color: { argb: 'FF000000' } },
      bottom: { style: 'thin', color: { argb: 'FF000000' } },
      left: { style: 'thin', color: { argb: 'FF000000' } },
      right: { style: 'thin', color: { argb: 'FF000000' } },
    };

    rows.forEach((row, index) => {
      const detail = validDetails.find((d) => String(d.HPH_PAYROLL_ID) === String(row.id));

      const compMap = {};
      detail?.PayrollDetails?.forEach((d) => {
        compMap[d.HPC_COMPONENT_NAME] = Number(d.HPD_AMOUNT || 0);
      });

      const rawFreq = String(row.payFrequency || selectedPeriod?.frequency || '').toUpperCase();
      const isWeekly = rawFreq === 'W' || rawFreq === 'WEEKLY';

      const presentDays = Number(detail?.HPH_PRESENT_DAYS ?? 0);
      const workingDays = isWeekly ? presentDays : Number(detail?.HPH_WORKING_DAYS ?? row.workingDays ?? 0);
      const noPayDays = isWeekly ? 0 : Number(detail?.HPH_NO_PAY_DAYS ?? 0);
      const extraDays = isWeekly ? 0 : Math.max(0, presentDays - workingDays);

      const employeeEpf = Number(detail?.HPH_EMPLOYEE_EPF ?? 0);
      const employerEpf = Number(detail?.HPH_EMPLOYER_EPF ?? 0);
      const employerEtf = Number(detail?.HPH_EMPLOYER_ETF ?? 0);

      const rowValues = [
        index + 1,
        detail?.HPH_PAYROLL_NO || '-',
        detail?.HPH_PAY_DATE ? String(detail.HPH_PAY_DATE).split(' ')[0] : '-',
        row.empNo,
        row.name,
        row.salaryReference || '-',
        row.status || '-',
        workingDays,
        presentDays,
        noPayDays,
        extraDays,
        Number(detail?.HPH_OT_HOURS ?? 0),
        Number(row.basicSalary || 0),
        ...dynamicEarnings.map((name) => (compMap[name] !== undefined ? compMap[name] : 0)),
        Number(detail?.HPH_GROSS_EARNINGS ?? row.grossSalary ?? 0),
        Number(detail?.HPH_TOTAL_EARNINGS ?? 0),
        employeeEpf,
        ...dynamicDeductions.map((name) => (compMap[name] !== undefined ? compMap[name] : 0)),
        Number(detail?.HPH_PAYE ?? 0),
        Number(detail?.HPH_TOTAL_DEDUCTIONS ?? 0),
        Number(detail?.HPH_NET_SALARY ?? 0),
        employerEpf,
        employerEtf,
        employerEpf + employerEtf,
      ];

      const addedRow = worksheet.addRow(rowValues);
      addedRow.height = 20;

      addedRow.eachCell((cell, colNumber) => {
        const colIdx = colNumber - 1;
        const isCurrency = colIdx >= 12;
        const isCenter = (colIdx >= 7 && colIdx <= 11) || colIdx === 0 || colIdx === 2 || colIdx === 6;

        cell.font = { name: 'Calibri', size: 10, color: { argb: 'FF374151' } };
        cell.border = borderBlack;

        if (isCurrency) {
          cell.alignment = { vertical: 'middle', horizontal: 'right' };
          cell.numFmt = '#,##0.00';
        } else if (isCenter) {
          cell.alignment = { vertical: 'middle', horizontal: 'center' };
        } else {
          cell.alignment = { vertical: 'middle', horizontal: 'left' };
        }
      });
    });

    // 5. Minimal Column Widths
    worksheet.columns.forEach((col) => {
      let maxLen = 0;
      col.eachCell({ includeEmpty: false }, (cell) => {
        const str = cell.value ? cell.value.toString() : '';
        if (str.length > maxLen) maxLen = str.length;
      });
      col.width = Math.max(maxLen + 3, 11);
    });

    // 6. Save
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `${periodName.replace(/[^a-zA-Z0-9_-]/g, '_')}_Summary.xlsx`);
  };

  const handlePrintAllSlips = async () => {
    if (!rows || rows.length === 0) return;

    setPrintingBatch(true);
    try {
      // Fetch full details for each employee
      const results = await Promise.all(
        rows.map(async (row) => {
          try {
            const data = await dispatch(getPayrollDetailsBySno(selectedPeriodId, row.empNo));
            if (!data) return null;

            const slipBreakdown = buildSalarySlipBreakdown(data);
            const slipHeader = {
              payrollNo: data.HPH_PAYROLL_NO,
              payrollPeriodId: data.HPH_PAYROLL_PERIOD_ID,
              employeeId: data.HPH_EMPLOYEE_ID,
              employeeSalaryId: data.HPH_EMPLOYEE_SALARY_ID,
              payDate: data.HPH_PAY_DATE ? String(data.HPH_PAY_DATE).split(' ')[0] : '',
              grossEarnings: Number(data.HPH_GROSS_EARNINGS || 0),
              totalEarnings: Number(data.HPH_TOTAL_EARNINGS || 0),
              totalDeductions: Number(data.HPH_TOTAL_DEDUCTIONS || 0),
              employeeEpf: Number(data.HPH_EMPLOYEE_EPF || 0),
              employerEpf: Number(data.HPH_EMPLOYER_EPF || 0),
              employerEtf: Number(data.HPH_EMPLOYER_ETF || 0),
              paye: Number(data.HPH_PAYE || 0),
              netSalary: Number(data.HPH_NET_SALARY || 0),
              workingDays: Number(data.HPH_WORKING_DAYS || 0),
              presentDays: Number(data.HPH_PRESENT_DAYS || 0),
              noPayDays: Number(data.HPH_NO_PAY_DAYS || 0),
              otHours: Number(data.HPH_OT_HOURS || 0),
              status: data.HPH_STATUS,
              remarks: data.HPH_REMARKS,
            }

            return {
              employee: {
                name: row.name,
                empNo: row.empNo,
              },
              period: selectedPeriod,
              header: slipHeader,
              breakdown: slipBreakdown
            }
          } catch (err) {
            console.error(`Failed to fetch details for ${row.empNo}: `, err);
            return null;
          }
        })
      )

      const validSlips = results.filter(Boolean);
      setBatchPrintData(validSlips);

      // Allow DOM to render the printable items, then trigger print
      setTimeout(() => {
        window.print();

        // Clear printable items after printing
        setTimeout(() => setBatchPrintData([]), 1000);
      }, 500);
    } catch (err) {
      console.error("Failed to prepare slips for printing: ", err);
    } finally {
      setPrintingBatch(false);
    }
  };

  const handleReversePayroll = async () => {
    if (!selectedPeriodId) return;

    const periodName = selectedPeriod?.name || `Period #${selectedPeriodId}`;

    const confirmed = await confirm({
      title: 'Reverse Payroll?',
      message: `Are you sure you want to reverse the payroll calculation for ${periodName}? This will permanently delete the calculated records for this period.`,
      confirmLabel: 'Reverse Payroll',
      cancelLabel: 'Cancel',
      variant: 'danger',
    });

    if (!confirmed) return;

    try {
      setReversing(true);
      await dispatch(reversePayroll(selectedPeriodId));
      showToast('Payroll reversed successfully.', 'success');

      // Refresh period list
      dispatch(fetchPayrollEntityList('payrollPeriods'));

      // Refresh headers
      dispatch(fetchPayrollHeadersByPeriod(selectedPeriodId));
    } catch (error) {
      showToast(error?.message || 'Failed to reverse paroll.', 'error');
    } finally {
      setReversing(false);
    }
  }

  return (
    <div className="p-6 space-y-4">
      <Breadcrumb
        trail={['Payroll', 'Payroll Header']}
        title="Payroll Header"
        subtitle="Payment details per employee and payroll period. View an employee's salary slip, print it, or download it as a PDF."
      />

      <Table
        title="Payroll Header"
        loading={salariesLoading || headersLoading}
        loadingMessage="Loading payroll records..."
        rows={rows}
        rowKey="id"
        search
        searchLabel="Search"
        searchKeys={['empNo', 'name', 'salaryReference']}
        searchPlaceholder="Search by employee name, number or salary reference..."
        emptyMessage={
          selectedPeriodId
            ? 'No payroll records for this period.'
            : 'Select a payroll period to view records.'
        }
        pageSize={8}
        scrollClassName=""
        toolbarExtra={
          <div className="flex items-end gap-3">
            <div className="w-[260px] max-w-full">
              <span className={LABEL}>Period ID</span>
              <SearchableSelect
                value={selectedPeriodId}
                onChange={(v) => {
                  setSelectedPeriodId(v);
                  handleCloseSlip();
                  refreshTable();
                }}
                options={periods
                  .filter((period) => period.status === "Inactive")
                  .map((period) => ({ value: String(period.id), label: period.name }))}
                emptyOption={{ value: '', label: '-- Select Period --' }}
                placeholder="-- Select Period --"
                searchPlaceholder="Search period..."
                className={`${FIELD} w-full`}
              />
            </div>

            {rows.length > 0 && (
              <button
                type="button"
                onClick={handleDownloadExcel}
                className="flex items-center gap-1.5 h-9 px-3.5 rounded-lg text-xs font-semibold bg-amber-600 text-white hover:bg-amber-700 transition-colors shadow-sm shrink-0"
              >
                <Download size={14} />
                Export to Excel
              </button>
            )}

            {rows.length > 0 && (
              <button
                type="button"
                onClick={handlePrintAllSlips}
                disabled={printingBatch}
                className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-lg text-xs font-semibold
                  border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-900 
                  transition-colors shadow-xs disabled:opacity-50 disabled:cursor-not-allowed shrink-0"
              >
                {printingBatch ? (
                  <Loader2 size={14} className="animate-spin text-amber-600" />
                ) : (
                  <Printer size={14} />
                )}
                {printingBatch ? "Preparing Slips..." : "Batch Print"}
              </button>
            )}
          </div>
        }
        columns={[
          {
            key: 'name',
            label: 'Employee',
            grow: true,
            className: 'font-semibold text-gray-900',
            render: (row) => `${row.name} (${row.empNo})`,
          },
          { key: 'salaryReference', label: 'Salary Reference', className: 'text-gray-600' },
          {
            key: 'basicSalary',
            label: 'Basic Salary (Rs)',
            align: 'right',
            className: 'text-gray-700',
            render: (row) => fmtMoney(row.basicSalary),
          },
          {
            key: 'grossSalary',
            label: 'Gross Salary (Rs)',
            align: 'right',
            className: 'font-semibold text-gray-900',
            render: (row) => fmtMoney(row.grossSalary),
          },
          {
            key: 'status',
            label: 'Status',
            align: 'center',
            render: (row) => <StatusPill label={row.status} />,
          },
          {
            key: 'actions',
            label: 'Actions',
            align: 'center',
            sortable: false,
            render: (row) => (
              <button
                type="button"
                onClick={() => handleViewSalarySlip(row)}
                className="inline-flex items-center gap-1.5 h-7 px-2 rounded-md text-[12px] font-semibold
                  text-primary-700 hover:bg-primary-50 transition-colors"
              >
                <Eye size={14} />
                View Salary Slip
              </button>
            ),
          },
        ]}
      />

      {selectedPeriodId && rows.length > 0 && (
        <div className="flex justify-end pt-2">
          <button
            type="button"
            disabled={reversing}
            onClick={handleReversePayroll}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold
              text-white bg-red-600 hover:bg-red-700 active:bg-red-800 disabled:opacity-50 
              disabled:cursor-not-allowed shadow-sm transition-colors"
          >
            <RotateCw size={16} className={reversing ? 'animate-spin' : ''} />
            {reversing ? 'Reversing Payroll...' : 'Reverse Payroll'}
          </button>
        </div>
      )}

      {viewing && (
        <div
          className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/40 px-4 py-8"
          onClick={handleCloseSlip}
        >
          <div
            className="relative w-full max-w-2xl rounded-xl bg-[#F7F7F7] shadow-lg"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={handleCloseSlip}
              aria-label="Close"
              className="salary-slip-actions absolute right-3 top-3 z-10 inline-flex h-8 w-8 items-center
                justify-center rounded-md text-gray-500 hover:bg-gray-200 hover:text-gray-700 transition-colors"
            >
              <X size={18} />
            </button>

            <div className="px-4 pb-4 pt-12">
              {detailsLoading && (
                <div className="py-20 text-center text-sm text-gray-400">Loading salary slip...</div>
              )}

              {!detailsLoading && detailsError && (
                <div className="py-16 text-center text-sm text-red-700">{detailsError}</div>
              )}

              {!detailsLoading && !detailsError && payrollDetails && breakdown && salarySlipHeader && (
                <SalarySlip
                  employee={viewingEmployee}
                  period={viewingPeriod}
                  header={salarySlipHeader}
                  breakdown={breakdown}
                />
              )}
            </div>
          </div>
        </div>
      )}

      <Toast 
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />

      {/* ── BATCH PRINT CONTAINER (Hidden on screen, visible only when printing all slips) ── */}
      <style>{`
        @page {
          size: A4 portrait;
          margin: 10mm;
        }

        @media print {
          body {
            margin: 0 !important;
            padding: 0 !important;
          }

          body > * {
            visibility: hidden !important;
          }

          #batch-salary-slips {
            display: block !important;
            visibility: visible !important;
            position: absolute !important;
            top: 0 !important;
            left: 0 !important;
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: visible !important;
          }

          #batch-salary-slips,
          #batch-salary-slips * {
            visibility: visible !important;
          }

          #batch-salary-slips .salary-slip-actions {
            display: none !important;
          }

          #batch-salary-slips .print-slip-page {
            display: block !important;
            position: relative !important;
            width: 100% !important;
            height: auto !important;
            min-height: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            overflow: visible !important;

            break-inside: avoid !important;
            page-break-inside: avoid !important;
            break-after: page !important;
            page-break-after: always !important;
          }

          #batch-salary-slips .print-slip-page:last-child {
            break-after: auto !important;
            page-break-after: auto !important;
          }

          #batch-salary-slips .print-slip-page > * {
            display: block !important;
            position: static !important;
            width: 100% !important;
            height: auto !important;
            margin: 0 !important;
            padding: 0 !important;
          }

          #batch-salary-slips .MuiPaper-root {
            display: block !important;
            position: static !important;
            width: 100% !important;
            height: auto !important;
            max-height: none !important;
            min-height: 0 !important;
            margin: 0 !important;
            padding: 0 !important;
            border: none !important;
            border-radius: 0 !important;
            box-shadow: none !important;
            overflow: visible !important;

            break-after: auto !important;
            page-break-after: auto !important;
          }

          .salary-slip-actions {
            display: none !important;
          }
        }
      `}</style>

      {batchPrintData.length > 0 && (
        <div id="batch-salary-slips" className="hidden print:block">
          {batchPrintData.map((item, index) => (
            <div key={index} className="print-slip-page">
              <SalarySlip
                slipId={`slip-print-${index}`}
                employee={item.employee}
                period={item.period}
                header={item.header}
                breakdown={item.breakdown}
                batchMode
              />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PayrollHeader;